import {ParentCaseInfo, ParentCaseInfoColumn} from "./domain";
import React from "react";
import {ParentCaseColumns} from "./ParentCaseList";
import {get} from "lodash";
import {ParentCaseListAction} from "./parentCaseListReducer";
import {formatDateStr} from "../../common/util/date";
import {LinkToNewTabKeepContext} from "common";
import { useApplicationRootUrl } from "common/component/ApplicationRootContext";

type ParentCasePreviewProps = {
    parentCase: ParentCaseInfo,
    selected: boolean,
    dispatch: React.Dispatch<ParentCaseListAction>
}

export function ParentCasePreview({parentCase, selected, dispatch}: ParentCasePreviewProps) {
    const rootUrl = useApplicationRootUrl();
    const displayColumn = (column: ParentCaseInfoColumn) => {
        if (column.attr === "client.fullName") {
            return (
                <LinkToNewTabKeepContext link={`${rootUrl}/clients/${parentCase?.clientGuid}/contacts`}>
                        <span className={`underline ${selected ? 'text-white' : 'text-blue-portal-link'}`}>
                                {get(parentCase, column.attr)}
                        </span>
                </LinkToNewTabKeepContext>
            )
        }

        if (column.attr === 'serviceTypes' && get(parentCase, 'serviceTypes')) {
            return <>
                {get(parentCase, 'serviceTypes').join(", ")}
            </>
        }

        if (column.attr === 'placementDate' && get(parentCase, 'placementDate')) {
            return <>
                {formatDateStr(get(parentCase, 'placementDate'))}
            </>
        }

        return (<>
            {get(parentCase, column.attr)}
        </>);
    }

    return (
        <tr className={`border-b border-gray-200 relative
            hover:${selected ? 'bg-botticelli-100' : 'bg-gray-200'}
            ${selected ? 'bg-botticelli-100 text-white' : ''}
            ${parentCase.isAtRisk ? 'bg-red-200 border-red-300 hover:bg-red-300' : ''}
          `}>
            {
                ParentCaseColumns.map((column) => (
                    <td
                        key={column.name}
                        className={'py-5' + (column.attr === 'caseNumber' ? ' pl-8' : '')}
                        onClick={() => dispatch({type: "SET_SELECTED", selected: parentCase})}
                    >
                        {
                            displayColumn(column)
                        }
                    </td>
                ))
            }
        </tr>
    );
}
